import { PropsWithChildren, useEffect } from "react";
import DateSelect from "../common/DateSelect";
import {
  Typography,
  CircularProgress,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
} from "@mui/material";
import { useFormikContext } from "formik";
import { RecordWithEnumeratedIndex, UnitsOfSale } from "../client/types";
import useFetchTotalUnitsOfSale from "./hooks/useFetchMetric";
import { Dates } from "../common/types";
import {
  CardHeading,
  CardWrapper,
  ElementWrapper,
  Error,
} from "./common-components";

const UnitsOfSaleCardContent = () => {
  const { values, isValid } =
    useFormikContext<RecordWithEnumeratedIndex<Dates<"unitsOfSale">, number>>();

  const { loading, error, fetchMetric, metric } =
    useFetchTotalUnitsOfSale<UnitsOfSale>("units of sale");

  useEffect(() => {
    if (isValid) {
      fetchMetric({
        fromDate: values[`unitsOfSale-start-date`],
        toDate: values[`unitsOfSale-end-date`],
      });
    }
  }, [values, fetchMetric, isValid]);

  const element = () => {
    if (loading) {
      return <CircularProgress />;
    }

    if (error || !metric) {
      return <Error />;
    }

    return (
      <Table sx={{ marginTop: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                Unit
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                Total
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(metric).map(([unit, total]) => (
            <TableRow key={unit}>
              <TableCell>
                <Typography sx={{ fontSize: 16, fontWeight: "bold" }}>
                  {unit}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography sx={{ fontSize: 16 }}>{Number(total)}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };

  return (
    <>
      <CardHeading heading="Total sales per unit of sale" />
      <DateSelect dateName="unitsOfSale" minDate={new Date("01/01/2020")} />
      <ElementWrapper>{element()}</ElementWrapper>
    </>
  );
};

const UnitsOfSaleCardWrapper = ({ children }: PropsWithChildren) => (
  <CardWrapper id="unitsOfSale">{children}</CardWrapper>
);

export const UnitsOfSaleCard = () => (
  <UnitsOfSaleCardWrapper>
    <UnitsOfSaleCardContent />
  </UnitsOfSaleCardWrapper>
);
